// Reducer extracted from ResourceBankModule.js

import _ from "lodash";
import update from "immutability-helper";
import {
  INITIALISE_RESOURCEBANK_COMPONENT,
  UPDATE_RESOURCEBANK_FILTERS,
  TOGGLE_RESOURCEBANK_FILTER_ITEM,
  TOGGLE_ALL_RESOURCEBANK_FILTER_ITEMS,
  TOGGLE_RESOURCEBANK_SELECTED_RESOURCES,
  CLEAR_RESOURCEBANK_SELECTED_RESOURCES,
} from "./ResourceBankConstants";

// Initial State
const initialState = {
  progressOfUploads: {
    //id: progress
  },
  resourceBank: {
    default: {
      filters: {
        searchText: "",
        count: 20,
        selected: {
          sources: ["Unsplash"],
          mediaTypes: ["image"],
        },
      },
      selectedResources: [],
    },
  },
};

const resourceBank = {
  filters: {
    searchText: "",
    count: 20,
    selected: {
      sources: ["Unsplash"],
      mediaTypes: ["image"],
    },
  },
  selectedResources: [],
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [INITIALISE_RESOURCEBANK_COMPONENT]: (state, action) => {
    return update(state, {
      resourceBank: { [action.data]: { $set: resourceBank } },
    });
  },
  [UPDATE_RESOURCEBANK_FILTERS]: (state, action) => {
    const params = action.data.params;
    const id = action.data.id;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        resourceBank: { [id]: { filters: { [key]: { $set: params[key] } } } },
      });
    });
    return state;
  },
  [TOGGLE_ALL_RESOURCEBANK_FILTER_ITEMS]: (state, action) => {
    const stateItemToUpdate = action.data.params.type;
    const id = action.data.id;
    return update(state, {
      resourceBank: {
        [id]: {
          filters: {
            selected: {
              [stateItemToUpdate]: { $set: action.data.params.allList },
            },
          },
        },
      },
    });
  },
  [TOGGLE_RESOURCEBANK_FILTER_ITEM]: (state, action) => {
    const params = action.data.params;
    const value = params.value;
    const opt = params.opt;
    const index = params.index;
    const stateItemToUpdate = params.type;
    const item = _.cloneDeep(params.item);
    const id = action.data.id;
    if (value) {
      return update(state, {
        resourceBank: {
          [id]: {
            filters: { selected: { [stateItemToUpdate]: { $push: [opt] } } },
          },
        },
      });
    } else {
      return update(state, {
        resourceBank: {
          [id]: {
            filters: {
              selected: { [stateItemToUpdate]: { $splice: [[index, 1]] } },
            },
          },
        },
      });
    }
  },
  [TOGGLE_RESOURCEBANK_SELECTED_RESOURCES]: (state, action) => {
    const {
      params: { type, data, index: arrayindex, multi },
      id,
    } = action.data;

    if (multi) {
      if (type == "add") {
        if (arrayindex == "") {
          state = update(state, {
            resourceBank: { [id]: { selectedResources: { $push: [data] } } },
          });
        } else {
          state = update(state, {
            resourceBank: {
              [id]: { selectedResources: { $splice: [[arrayindex, 0, data]] } },
            },
          });
        }
      } else if (type == "delete") {
        state = update(state, {
          resourceBank: {
            [id]: { selectedResources: { $splice: [[arrayindex, 1]] } },
          },
        });
      } else {
        state = update(state, {
          resourceBank: {
            [id]: { selectedResources: { $splice: [[arrayindex, 1, data]] } },
          },
        });
      }
    } else {
      state = update(state, {
        resourceBank: {
          [id]: { selectedResources: { $set: type === "add" ? [data] : [] } },
        },
      });
    }
    return state;
  },
  [CLEAR_RESOURCEBANK_SELECTED_RESOURCES]: (state, action) => {
    const id = action.data.id;
    return update(state, {
      resourceBank: { [id]: { selectedResources: { $set: [] } } },
    });
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { initialState, REDUCER_HANDLERS };
